"use strict";
/**
 * The creator-acquisition funnel as Meta sees it: one dataset, and one name per
 * step whether the creator came through the website or the NewForm One app.
 *
 * | Step                 | Event                        | Sent by                                          |
 * | -------------------- | ---------------------------- | ------------------------------------------------ |
 * | Applied              | `SubmitApplication`          | /join pixel and its server copy                 |
 * | Application approved | `CreatorApplicationApproved` | backend, for web and app applicants              |
 * | First video submitted| `CreatorFirstVideoSubmitted` | web pixel + server copy, or iOS SDK              |
 * | A video approved     | `CreatorVideoApproved`       | backend, for web and app applicants              |
 *
 * The published iOS app keeps `CreatorApplicationSubmitted` until its existing
 * SKAN/AEM application mapping is migrated. Native event names also live in
 * `MetaAppEvents.swift`, which cannot import this file.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEGACY_WEB_APPLIED_EVENT = exports.CREATOR_FUNNEL_EVENTS = exports.CREATOR_ACQUISITION_DATASET_ID = void 0;
exports.creatorApplicationEventId = creatorApplicationEventId;
exports.creatorFirstVideoSubmissionEventId = creatorFirstVideoSubmissionEventId;
/**
 * The NewForm.AI Website pixel. /join loads it in the browser, the backend
 * writes server events into it, and the NewForm One app is linked to it.
 */
exports.CREATOR_ACQUISITION_DATASET_ID = "1030408012353369";
exports.CREATOR_FUNNEL_EVENTS = {
    /** An application entered the review queue, on the web or in the app. */
    applied: "SubmitApplication",
    /** Staff accepted the application into one or more programs. */
    applicationApproved: "CreatorApplicationApproved",
    /** Once per creator, when an original upload is accepted and persisted. */
    firstVideoSubmitted: "CreatorFirstVideoSubmitted",
    /**
     * One of their videos was approved: the deep-funnel event. Once per
     * applicant, at the first approval that can be reported.
     */
    videoApproved: "CreatorVideoApproved",
};
/**
 * The website's name for applying before the platforms shared one. The live
 * recruitment ad sets optimise on it, and changing an ad set's optimisation
 * event restarts its learning, so /join keeps firing it beside
 * `SubmitApplication` until Marketing has moved them over. Delete it then.
 */
exports.LEGACY_WEB_APPLIED_EVENT = "Lead";
/**
 * The id Meta deduplicates on, per (event name, event id), so the browser's
 * `SubmitApplication` and the server's copy count once.
 *
 * Keyed on the signature as well as the application, because a re-application
 * after a rejection is a new application from the ad that brought them back.
 */
function creatorApplicationEventId(applicationId, agreementSignedAt) {
    return `creator-application-submitted:${applicationId}:${agreementSignedAt.getTime()}`;
}
function creatorFirstVideoSubmissionEventId(creatorId) {
    return `creator-first-video-submitted:${creatorId}`;
}
